import apiLambdaInsumo from "./apiLambdaInsumo"

function tratamentoResponse(response, chamada) {
    if (response.data.mensagem) return { retornoErro: 1, mensagem: response.data.mensagem }
    else if (typeof response.data == "string" && response.data != "")
        return {
            retornoErro: 1,
            mensagem: chamada + " - Erro inesperado, entre em contato com os reponsáveis.",
        }
    else return response.data
}

const ErroRequisicao = data => {
    try {

        if (data.message === "Network Error") {
            return "Verifique sua conexão!"
        }

        if (data.request && data.request.responseText) {
            const resposta = JSON.parse(data.request.responseText)
            return resposta.mensagem || "Erro desconhecido!"
        }

        return "Erro inesperado na requisição!"
    } catch (error) {
        // RegistrarLogErro(error, "ErroRequisicao", data)
        return "Erro ao tratar requisição!"
    }
}

export const buscarInsumos = async (idEstabelecimento, autorizacao) => {
    const url = `/insumo/buscarTodos/${idEstabelecimento}`
    const headers = {
        "Content-Type": "application/json",
        Authorization: autorizacao,
    }

    try {
        const response = await apiLambdaInsumo.get(url, { headers: headers })

        return tratamentoResponse(response, "Inusumo")
    } catch (error) {
        const erro = ErroRequisicao(error)
        return { retornoErro: 1, mensagem: erro }
        // RegistrarLogErro(error, "cadastrarCategoria")
    }
}

export const cadastrarInusmo = async (idEstabelecimento, data, autorizacao) => {
    const url = `/insumo/cadastrar/${idEstabelecimento}`
    const headers = {
        "Content-Type": "application/json",
        Authorization: autorizacao,
    }

    try {
        const response = await apiLambdaInsumo.post(url, data, { headers: headers })
        return tratamentoResponse(response, "Inusumo")
    } catch (error) {
        const erro = ErroRequisicao(error)
        return { retornoErro: 1, mensagem: erro }
        // RegistrarLogErro(error, "cadastrarCategoria")
    }
}

export const atualizarInsumo = async (idEstabelecimento, idInsumo, data, autorizacao) => {
    const url = `/insumo/atualizar/${idEstabelecimento}/${idInsumo}`
    const headers = {
        "Content-Type": "application/json",
        Authorization: autorizacao,
    }

    try {
        const response = await apiLambdaInsumo.put(url, data, { headers: headers })
        return tratamentoResponse(response, "Inusumo")
    } catch (error) {
        const erro = ErroRequisicao(error)
        return { retornoErro: 1, mensagem: erro }
        // RegistrarLogErro(error, "cadastrarCategoria")
    }
}

export const deletarInusmo = async (idEstabelecimento, idInsumo, autorizacao) => {
    const url = `/insumo/deletar/${idEstabelecimento}/${idInsumo}`
    const headers = {
        "Content-Type": "application/json",
        Authorization: autorizacao,
    }

    try {
        const response = await apiLambdaInsumo.delete(url, { headers: headers })

        return tratamentoResponse(response, "Inusumo")
    } catch (error) {
        const erro = ErroRequisicao(error)
        return { retornoErro: 1, mensagem: erro }
        // RegistrarLogErro(error, "cadastrarCategoria")
    }
}

export const buscarHistorico = async (idEstabelecimento, inicio, fim, autorizacao) => {
    const url = `/insumo/historico/${idEstabelecimento}?inicio=${inicio}&fim=${fim}`
    const headers = {
        "Content-Type": "application/json",
        Authorization: autorizacao,
    }

    try {
        const response = await apiLambdaInsumo.get(url, { headers: headers })

        return tratamentoResponse(response, "Inusumo")
    } catch (error) {
        const erro = ErroRequisicao(error)
        return { retornoErro: 1, mensagem: erro }
        // RegistrarLogErro(error, "cadastrarCategoria")
    }
}

export async function exportarCSV(idEstabelecimento, inicio, fim, autorizacao) {
    const url = `/insumo/historico/export/${idEstabelecimento}?inicio=${inicio}&fim=${fim}`

    try {
        const response = await apiLambdaInsumo.get(url, {
            responseType: "blob",
            headers: {
                Accept: "text/csv",
                Authorization: autorizacao,
            },
        })

        let filename = `historico-${inicio}-a-${fim}.csv`
        const dispo = response.headers?.["content-disposition"]
        if (dispo) {
            const m = /filename\*?=(?:UTF-8''|")?([^";]+)"?/i.exec(dispo)
            if (m && m[1]) filename = decodeURIComponent(m[1])
        }

        return { blob: response.data, filename }
    } catch (error) {
        const erro = ErroRequisicao(error)
        return { retornoErro: 1, mensagem: erro }
    }
}
